"use client"

import { useState } from "react"
import dynamic from "next/dynamic"
import { Search } from "lucide-react"

// T13: el modal solo se carga cuando el usuario abre la búsqueda por
// primera vez (antes el chunk de Meilisearch/instantsearch viajaba en
// TODAS las páginas: el móvil se arregló en T13, pero el desktop montaba
// el modal eager en el nav → chunk 7618 en el audit de 2026-08-25).
const SearchModal = dynamic(
  () => import("@modules/search/components/modal"),
  { ssr: false }
)

type Props = { desktop?: boolean }

export default function SearchButton({ desktop = false }: Props) {
  const [showSearch, setShowSearch] = useState(false)

  return (
    <>
      {desktop ? (
        /* Botón de búsqueda para desktop (antes el modal eager del nav) */
        <button
          onClick={() => setShowSearch(true)}
          className="flex items-center gap-2 px-0 text-small-regular text-ui-fg-subtle hover:text-ui-fg-base"
          aria-label="Abrir búsqueda"
        >
          <Search className="h-5 w-5" />
          Buscar
        </button>
      ) : (
        /* Botón de búsqueda para móvil - visible solo en pantallas pequeñas */
        <button
          onClick={() => setShowSearch(true)}
          className="flex small:hidden items-center justify-center p-2"
          aria-label="Buscar"
        >
          <Search className="w-5 h-5" color="#F599A6" />
        </button>
      )}

      {/* Panel de búsqueda (móvil o desktop; forceMobile solo oculta el
          trigger interno del panel y lo abre directamente) */}
      {showSearch && (
        <SearchModal
          onClose={() => setShowSearch(false)}
          forceMobile={true}
        />
      )}
    </>
  )
}
